export default "__VITE_ASSET__fe1676c6__"